//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"BottomingPlateClearance",1,0],[0,"BottomingPlateToggle",1,0],[0,"DiePlateClearance",1,0],[0,"DiePlateToggle",1,0],[0,"FaceEdgeType",1,0],[0,"InsertInstanceTag",1,"TaggedObject",0],[0,"InsertType",1,0],[0,"ParentPartName",1,0],[0,"ParentPartNode",1,0],[0,"PunchPlateClearance",1,0],[0,"PunchPlateToggle",1,0],[0,"RenameComponent",1,0],[1,"SelectFace",0,"ScCollector",0],[0,"StripperPlateClearance",1,0],[0,"StripperPlateToggle",1,0],[0,"WizardType",1,0]],[[[],"StandardInsert",{},0,0],[[],"UpdateInsertPartData",{},0,0],[[],"PreparePDWStandardClientData",{},0,0],[[],"PostProcessPDWStandardClientData",{R_:{createdInstanceTag:"TaggedObject"}},0,0],[["numParentNames"],"GetParentNames",{R_:{parentNames:""}},0,0],[["parentNames"],"SetParentNames",{},1,0],[["nSelectedFaceOccurrences","selectedFaceOccurrences"],"GetSelectedFaceOccurrences",{},0,0],[["selectedFaceOccurrences"],"SetSelectedFaceOccurrences",{},1,0]],[]];
SPLM.Tooling.ChamferingInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ChamferingInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ChamferingInsertBuilder.ParentPartNodeOption = Object.freeze({
    "NoParent" : "NoParent"});

SPLM.Tooling.ChamferingInsertBuilder.InsertTypeOption = Object.freeze({
    "Up" : "Up", "Down" : "Down", "All" : "All"});

SPLM.Tooling.ChamferingInsertBuilder.FaceEdgeTypeOption = Object.freeze({
    "StraightChamfer" : "StraightChamfer", "InnerCircle" : "InnerCircle", "InnerProfile" : "InnerProfile"});

export default SPLM;